import { HttpErrorResponse } from "@angular/common/http";
import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Product } from "src/app/models/product.model";

@Component({
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomePage {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  onProductSelected(product: Product) {
    let referer = this.getReferer();
    referer = encodeURIComponent(referer);
    const productId = encodeURIComponent(product.productId);
    const productModelName = encodeURIComponent(product.productModelName);
    this.router.navigateByUrl(
      `/${productId}?title=${productModelName}&referer=${referer}`,
    );
  }

  onError(error: HttpErrorResponse) {
    let referer = this.getReferer();
    referer = encodeURIComponent(referer);
    if (error.status >= 500 && error.status < 600) {
      this.router.navigateByUrl(`/error?referer=${referer}`);
    } else {
      this.router.navigateByUrl(`/access-denied-select-product`);
    }
  }

  private getReferer(): string {
    return "/" + this.route.snapshot.url.toString() + window.location.search;
  }
}
